import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidCEP, isValidCNPJ, isValidCPF, isValidMobilePhone } from '@brazilian-utils/brazilian-utils';
import * as moment from 'moment';

export class CustomValidators {

    static cpf(control: AbstractControl) {

        const { value } = control;
        if(value && isValidCPF(value.replace(/[^0-9]/gmi, '')))
            return null;

        return { cpf: { invalid: true } };

    }

    static cnpj(control: AbstractControl) {

        const { value } = control;
        if(value && isValidCNPJ(value.replace(/[^0-9]/gmi, '')))
            return null;

        return { cnpj: { invalid: true } };

    }

    static cep(control: AbstractControl) {

        const { value } = control;
        if(value && isValidCEP(value.replace(/[^0-9]/gmi, '')))
            return null;

        return { cep: { invalid: true } };

    }

    static phone(control: AbstractControl) {

        const { value } = control;
        if(value && isValidMobilePhone(value.replace(/[^0-9]/gmi, '')))
            return null;

        return { cep: { invalid: true } };       

    }

    public static match(field: string)  {

        return (controls: AbstractControl) => {
  
          if(controls.parent) {            
            let matching_value = controls.parent.get(field).value;
            let { value } = controls;
            return value === matching_value ? null: { match: true }
          }
  
          return null;
        }
  
    }

    public static beforeDate(field: string, format: string = 'DD/MM/yyyy') {

        return (controls: AbstractControl) => {
  
            if(controls.parent) {

                const maxDateValue = controls.parent.get(field).value;
                const { value } = controls;

                const dateNow = moment(value, format);
                const maxDate = moment(maxDateValue, format)
                
                if(dateNow.isAfter(maxDate))
                    return { beforeDate: true }

                return null;
              
            }
            
            return null;
          }

    }

    public static afterDate(field: string, format: string = 'DD/MM/yyyy') {

        return (controls: AbstractControl) => {
  
            if(controls.parent) {

                const minDateValue = controls.parent.get(field).value;
                const { value } = controls;

                const dateNow = moment(value, format);
                const minDate = moment(minDateValue, format)
                
                if(dateNow.isBefore(minDate))
                    return { afterDate: true }

                return null;
              
            }
            
            return null;
          }

    }

    public static date(format: string = 'DD/MM/yyyy') {

        return (control: AbstractControl) => {

            const { value } = control;

            if(value === null) return null;            
            if(!moment(value, format).isValid())
                return { invalidDate: true }

            return null;

        }

    }

    public static minDate(minDateField: any, format: string = 'DD/MM/yyyy') {

        return (controls: AbstractControl) => {

            const { value } = controls;
            
            if(value === null) return null;

            const dateNow = moment(value, format);
            const minDate = moment(minDateField.format(format), format)
            
            if(dateNow.isBefore(minDate))
                return { minDate: true }

            return null;

        }

    }

    public static maxDate(maxDateField: any, format: string = 'DD/MM/yyyy') {

        return (controls: AbstractControl) => {

            const { value } = controls;
            
            if(value === null) return null;

            const dateNow = moment(value, format);
            const maxDate = moment(maxDateField.format(format), format)
            
            if(dateNow.isAfter(maxDate))
                return { maxDate: true }

            return null;

        }

    }

    public static departureDate(field: string) {

        return (controls: AbstractControl) => {
  
            if(controls.parent) { 
              const currentJob = controls.parent.get(field).value;
              const { value } = controls;
              return currentJob === false && value === null ? { departure: true } : null;
            }
            
            return null;
          }

    }

    static expirationDate(triggerValidation: boolean = false): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!triggerValidation && !control.dirty) {
                return null; // Skip validation if not dirty and validation trigger is false
            }

            const value = control.value;
            if (value == null) {
                return { expirationDate: { required: true } }; // Or any other error you wish to return
            }

            const cleanValue = value.toString().replace(/[^0-9]/g, '');

            const regex = /^(0[1-9]|1[0-2])(\d{4})$/;
            if (regex.test(cleanValue)) {
                const month = parseInt(cleanValue.substring(0, 2), 10);
                const year = parseInt(cleanValue.substring(2), 10);
                const currentYear = new Date().getFullYear();
                const currentMonth = new Date().getMonth() + 1;

                if (year < currentYear % 100 || (year === currentYear % 100 && month < currentMonth)) {
                    return { expirationDate: { pastDate: true } };
                }

                return null;
            }

            return { expirationDate: { invalid: true } };
        };
    }

}